<style lang="stylus">
.take-photo-of-id {
  display: inline-block;
  font-size: 16px;
  color: #E8E8E8;
  font-weight: 400;
  width: 92px;
  margin-left: 8px;
}

.id-card::after {
  display: inline-block;
  display: inline-block;
  content: '';
  width: 305px;
  height: 219px;
  border-width: 2px;
  border-style: dashed;
  border-color: #8c1d30;
  position: absolute;
  transform: translate(-2px, 0px);
}

.yellowCircle-take--id-photo {
  font-size: 24px;
  color: rgb(51, 49, 48);
  background-color: #ffc527;
  border: 2px solid #ffc527;
  border-radius: 50%;
  padding: 7px 7.63px 5px 13.63px;
  margin-right: 12px;
  font-weight: bold;
}

.v-btn.valid-id-button {
  background-color: #fec627 !important;
  color: black !important;
}

.v-btn.invalid-id-button {
  background-color: #d7d7d7 !important;
  color: #666666 !important;
}
</style>
<template>
  <v-row class="step-1-take-photo-bg" align-center justify="center" row wrap>
    <v-container class="container">
      <v-col cols="12" md="12" sm="12" style="background-color: #fff">
        <v-container class="container">
          <div class="take-your-photo" id="takePhoto">
            <span
              class="yellowCircle-take--id-photo"
              style="background-color: #ffc527; color: black; border: 2px solid #ffc527"
              >2&nbsp;</span
            >Take a photo of your ID
          </div>
          <v-row wrap>
            <v-col cols="12" lg="5" md="12" sm="12">
              <image-capture-component @clickedImage="clickedImage" @retakeImage="retakeImage" :step="2" />
            </v-col>
            <v-col cols="1" lg="1" />
            <v-col cols="12" lg="5" md="12" sm="6" take-photo-steps-div>
              <div class="take-photo-steps">Now, take a picture of your photo ID card.</div>
              <div style="font-weight: 400; margin-bottom: 32px" class="generic-left-margin">
                Acceptable photo IDs include a driver’s license, passport, national ID card, state or province ID card,
                or an official student ID card.
              </div>
              <div class="take-photo-steps">Tips on taking a successful photo</div>
              <div style="margin-bottom: 12px; padding-left: 20px; font-weight: 400">
                <div
                  style="
                    background-color: black;
                    width: 8px;
                    height: 8px;
                    border-radius: 5px;
                    display: inline-block;
                    margin-right: 6px;
                  "
                />
                Hold your photo ID up to your webcam and click the camera button (
                <v-icon color="black" size="20px">mdi-camera</v-icon>&nbsp;).
              </div>
              <div style="margin-bottom: 32px; padding-left: 20px; font-weight: 400">
                <div
                  style="
                    background-color: black;
                    width: 8px;
                    height: 8px;
                    border-radius: 5px;
                    display: inline-block;
                    margin-right: 6px;
                  "
                />
                If you need to retake your photo, click the camera button (
                <v-icon color="black" size="20px">mdi-camera</v-icon>&nbsp;) again.
              </div>
              <div style="margin-bottom: 48px; font-weight: 400" class="generic-left-margin">
                When you’re satisfied with your photo, click “Next.”
              </div>
              <div class="nextButton generic-left-margin" style="display: flex; align-items: center; margin-left: 0">
                <v-btn
                  @click="goToIdReviewPhotos()"
                  :ripple="false"
                  :disabled="idVerifyPhotoID"
                  variant="flat"
                  :class="!!idVerifyPhotoID ? 'invalid-button' : ''"
                >
                  <span style="padding-left: 17px">Next</span>
                  <v-icon left style="margin: 0 10px">mdi-arrow-right</v-icon>
                </v-btn>

                <span class="take-photo-of-id">Review your photos</span>
              </div>
            </v-col>
            <v-col cols="1" lg="1" />
          </v-row>
          <v-divider />
          <v-row wrap>
            <v-col cols="12" lg="6" md="12" sm="12">
              <div class="step-1-question-header">Why does ASU need my photo?</div>
              <div class="step-1-question-content">
                To be eligible for academic credit, you must verify your identification so we know who you are. This
                lets us ensure the academic credit you earn appears on your official ASU transcript.
              </div>
            </v-col>
            <v-col cols="12" lg="6" md="12" sm="12">
              <div class="step-1-question-header">What does ASU do with this photo?</div>
              <div class="step-1-question-content">
                We use the highest levels of security available to encrypt your photo and send it to our authorization
                service for review. Your photo and information are not saved or visible anywhere on ASU after the
                verification process is complete.
              </div>
            </v-col>
          </v-row>
          <div class="take-photo-questions d-flex d-sm-none" style="margin-top: 0">
            <span style="font-weight: 900">Questions?</span> Please
            <span
              style="color: #8c1d40; text-decoration: underline"
              v-on:click="
                asuoDataLayerClick('idVerifiyStep1', '5', {});
                gotoFAQ();
              "
              >read our FAQ</span
            >
            to view common questions.
          </div>
        </v-container>
      </v-col>
    </v-container>
  </v-row>
</template>
<script>
import { defineComponent } from 'vue';

import ImageCaptureComponent from './ImageCaptureComponent.vue';

export default defineComponent({
  emits: ['goToStep'],

  data() {
    return {
      idVerifyPhotoID: true
    };
  },

  components: {
    ImageCaptureComponent
  },

  methods: {
    goToIdReviewPhotos() {
      this.$emit('goToStep', { step: 3 });
    },
    retakeImage() {
      this.idVerifyPhotoID = true;
    },
    clickedImage() {
      this.idVerifyPhotoID = false;
    },
    scrollto() {
      let pos = document.getElementById('takePhoto') != null ? document.getElementById('takePhoto').offsetTop : 0;

      window.scrollTo(0, pos - 30);
    }
  },

  created() {
    this.scrollto();
  }
});
</script>
